export default __webpack_public_path__ + "static/media/technologyblue.21346666.svg";